import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpApiService {
  private apiUrl: string;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.apiUrl;
  }

  public get<T>(endpoint: string, params?: any, cookies?: string,  responseType: 'json' | 'blob' | 'text' = 'json'): Observable<T> {
    let httpParams = new HttpParams();
    if (params) {
      for (const key of Object.keys(params)) {
        httpParams = httpParams.set(key, params[key]);
      }
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.get<T>(`${this.apiUrl}/${endpoint}`,
      { headers,
        params: httpParams,
        responseType: responseType as 'json',
      withCredentials: true });
  }

  public post<T>(endpoint: string, data: any, cookies?: string): Observable<T> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.post<T>(`${this.apiUrl}/${endpoint}`, data, options);
  }

  public delete<T>(endpoint: string, params?: any, cookies?: string): Observable<T> {
    let httpParams = new HttpParams();
    if (params) {
      for (const key of Object.keys(params)) {
        httpParams = httpParams.set(key, params[key]);
      }
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.delete<T>(`${this.apiUrl}/${endpoint}`,
      { headers,
        params: httpParams,
        withCredentials: true });
  }
}
